import getOngoingOnboarding from 'api/v2/transactions/getOngoingOnboarding';
import useQuery from 'hooks/react-query/useQuery';

import { BankTransactionsCacheKeys } from 'types/cacheKeys.types';

const useGetBankingOnboardingStatus = () =>
  useQuery([BankTransactionsCacheKeys.OngoingOnboarding], getOngoingOnboarding);

export default useGetBankingOnboardingStatus;
